export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s nem lett kiválasztva';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s nem lehet üres';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = 'A %s megadása kötelező';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s nem lett kitöltve megfelelően';
                break;

            case 'opt-in':
                translation = 'A folytatáshoz jelölje be a négyzetet';
                break;

            default:
                translation = 'A mező nem lett kitöltve megfelelően';
                break;
        }

        return translation;
    }
}
